import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Alert, Button, Spin } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import { gradeManagementAPI } from '../services/api';

export const fixedManagementHome = user => {
  if (user?.username === 'admin' || ['admin', 'platform_admin', 'super_admin'].includes(user?.role)) return '/dashboard';
  return user?.role === 'school_admin' ? '/school-admin' : null;
};

export default function ManagementLanding({ children }) {
  const { user } = useAuth();
  const fixed = fixedManagementHome(user);
  const [result, setResult] = useState({ key: '', path: null, error: false });
  const [retry, setRetry] = useState(0);
  const key = `${user?.id || ''}:${user?.role || ''}`;
  useEffect(() => {
    if (fixed || user?.role !== 'teacher') return;
    let active = true;
    gradeManagementAPI.context().then(response => {
      if (!response.data?.success) throw new Error('Grade context unavailable');
      const granted = (response.data.data?.scopes || []).some(scope => scope.administrator === false);
      if (active) setResult({ key, path: granted ? '/grade-management' : '/dashboard', error: false });
    }).catch(() => { if (active) setResult({ key, path: null, error: true }); });
    return () => { active = false; };
  }, [key, fixed, retry, user?.role]);
  if (fixed === '/school-admin') return <Navigate to={fixed} replace />;
  if (fixed || user?.role !== 'teacher') return children;
  if (result.key !== key || (!result.path && !result.error)) return <Spin tip="读取管理权限"><div style={{ minHeight: 100 }} /></Spin>;
  if (result.error) return <Alert type="error" showIcon message="管理权限读取失败" description="请重试后进入你的工作台。"
    action={<Button onClick={() => { setResult({ key: '', path: null, error: false }); setRetry(value => value + 1); }}>重试</Button>} />;
  return result.path === '/grade-management' ? <Navigate to={result.path} replace /> : children;
}
